import React from 'react';
import { ListItemText, Stack, Box } from '@mui/material';

import { ColorPicker, ColorPickerWithLabel, TextField } from '@occc-app/design-system';

import { OfferNameAndDescriptionConfiguration } from '@occc-app/routes/Offer/components/OfferNameAndDescriptionConfiguration';
import { OfferFulfillmentPriorityField } from '@occc-app/offerHelpers/components/OfferFulfillmentPriorityField';
import { GameType } from '../../types';

type SectionHeaderProps = {
  primary: string;
  secondary: string;
};
const SectionHeader = (props: SectionHeaderProps) => {
  return (
    <Box>
      <ListItemText
        primary={props.primary}
        secondary={props.secondary}
        primaryTypographyProps={{ fontWeight: 'bold' }}
      />
    </Box>
  );
};

const SpinWheelGameConfiguration = () => {
  return (
    <Stack spacing={2} flex={1}>
      <Stack spacing={1}>
        <Box>
          <OfferNameAndDescriptionConfiguration entityName='Game' />
          <OfferFulfillmentPriorityField mt={2} />
        </Box>
      </Stack>

      <Stack spacing={1}>
        <SectionHeader
          primary='Game Title'
          secondary='The title to be displayed within the game window'
        />
        <Stack direction='row' spacing={2}>
          <TextField name='spinWheelGameConfig.headerText' label='Game Title' sx={{ flex: 1 }} />
          <ColorPickerWithLabel name='spinWheelGameConfig.headerTextColor' label='Text Color' />
        </Stack>
      </Stack>

      <Stack spacing={1} alignItems='flex-start'>
        <SectionHeader primary='Disclaimer' secondary='Disclaimer text below the wheel' />
        <ColorPickerWithLabel name='spinWheelGameConfig.footerTextColor' label='Text Color' />
      </Stack>

      <Stack spacing={1}>
        <SectionHeader
          primary='Call to Action'
          secondary='Interactive button that starts the game when clicked on'
        />
        <Stack direction='row' spacing={2}>
          <ColorPickerWithLabel name='spinWheelGameConfig.buttonTextColor' label='Text Color' />
          <ColorPickerWithLabel name='spinWheelGameConfig.buttonColor' label='Button Color' />
        </Stack>
      </Stack>

      <Stack spacing={1} alignItems='flex-start'>
        <SectionHeader primary='Wheel Rim Color' secondary='The outer rim of the wheel' />
        <ColorPickerWithLabel name='spinWheelGameConfig.borderColor' label='Rim Color' />
      </Stack>

      <Stack spacing={1}>
        <SectionHeader primary='Background' secondary='The background behind the game wheel' />
        <Stack direction='row' spacing={2}>
          <ColorPicker name='spinWheelGameConfig.backgroundPrimaryColor' />
          <ColorPickerWithLabel
            name='spinWheelGameConfig.backgroundSecondaryColor'
            label='Background Colors'
          />
        </Stack>
        <Stack direction='row' spacing={2}>
          <TextField
            name='spinWheelGameConfig.backgroundImage'
            label='Background Image URL'
            fullWidth
          />
          <TextField
            name='spinWheelGameConfig.foregroundImage'
            label='Foreground Image URL'
            fullWidth
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

type GamePreviewProps = {
  gameType: GameType;
};
export const GameConfiguration = (props: GamePreviewProps) => {
  const { gameType } = props;
  if (gameType === GameType.SPIN_THE_WHEEL) {
    return <SpinWheelGameConfiguration />;
  }
  // Add more game types here
  return null;
};
